var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.349,
    cy: 0.244,
    r: 0.698,
    gradientTransform: "translate(0.27 -0.175) rotate(44.396)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d57b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16328a"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 18,
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.47,39.46l-4.3-15.09A.17.17,0,0,0,32,24.2a.16.16,0,0,0-.17.17L27.51,39.46a.35.35,0,0,0,.07.29q.06.11.24,0l4-1.5a.47.47,0,0,1,.33,0l4,1.5c.13.07.22.07.28,0A.26.26,0,0,0,36.47,39.46Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-3 32 32;3 32 32;-3 32 32",
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.51431277c4c17676e55a7c96e9917cc1.svg";
export { ForwardRef as ReactComponent };